import React, { useEffect } from "react";
import HelmetComponent from "../../utils/HelmetHelper";
import history from "../../history";
import { requireUserLogin, requireUserVerify } from "../../routes/Auth";
import requireUsernameChange from "../../routes/Auth/HOCs/requireUsernameChange";
import { handleAdFormLayoutMobile } from "../../HOCs";
import {
  getAdData,
  getControls,
  selectAdData,
  selectControls,
  setAdData
} from "../../routes/AdForm/adForm.ducks";
import { useDispatch, useSelector } from "react-redux";
import { LocalStorageKey, PageRoute } from "../../models";
import {
  checkEmptyArray,
  checkEmptyObject,
  localStorage,
  notification
} from "../../services";
import EditTitle from "./EditTitle";
import { mapCategoryToHr, mapModuleToHr } from "../../routes/LanguageMapper";
import StepHeader from "../AdFormPage/StepHeader";
import BackButton from "../AdFormPage/StepHeader/BackButton";

const showErrorOnFetch = () => {
  const actionButton = {
    text: "Moji oglasi",
    onClick: () => history.replace(PageRoute.myAd)
  };

  notification.showErrorWithAction(
    "Nije moguće učitati detalje oglasa",
    actionButton
  );
};

const EditModulePage = props => {
  const {
    location: { state }
  } = props;

  const dispatch = useDispatch();

  const adData = useSelector(selectAdData);
  const controls = useSelector(selectControls);

  useEffect(() => {
    const { match } = props;
    const adIdParam = match.params.id;

    if (state && state.skipAsking) {
      const localData = localStorage.getItem(LocalStorageKey.savedForm);

      if (checkEmptyObject(localData)) {
        dispatch(setAdData(localData));
      }
    } else if (adIdParam) {
      dispatch(getAdData(adIdParam, showErrorOnFetch));
    }
  }, []);

  useEffect(() => {
    if (!checkEmptyArray(controls) && checkEmptyObject(adData)) {
      dispatch(
        getControls(
          mapModuleToHr(adData.module),
          mapCategoryToHr(adData.category),
          [],
          adData
        )
      );
    }
  }, [adData]);

  return (
    <React.Fragment>
      <HelmetComponent
        title={`${"Uredite oglas"} | ${"INDEX OGLASI"}`}
        index={false}
      />
      <StepHeader
        leftButton={<BackButton onClick={() => history.push(PageRoute.myAd)} />}
      />

      <EditTitle {...props} title={"Odaberite kategoriju"} />
    </React.Fragment>
  );
};

export default requireUserLogin(
  requireUsernameChange(
    requireUserVerify(
      handleAdFormLayoutMobile(
        EditModulePage
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/containers/EditModulePage/index.tsx